import React, { useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import { TranslationContext } from "../../contexts/TranslationContext";
import { SaveService } from "../../services/SaveService";
import { ErrorFlag, IUserSolution } from "../../services/WebApiClient";
import { LoadSpinner } from "../LoadSpinner";
import { EditorContext } from "./EditorContext";
import { LoginContext } from "./LoginContext";


export function SaveModal(props: {
    errorFlags: ErrorFlag,
    onClose: () => void,
    onSaved: (userSolution: IUserSolution) => void
}) {

    const tc = useContext(TranslationContext);
    const ec = useContext(EditorContext);
    const loginContext = useContext(LoginContext);

    const [isWorking, setIsWorking] = useState(false);
    const [name, setName] = useState(ec.cabinet.name);

    const canSave = !!name && !isWorking;
    const canOverwrite = (
        ec.cabinet.userSolutionId !== null
        && ec.cabinet.orderNumber === null
    );

    async function save(overwrite: boolean) {
        if (!canSave)
            return;
        try {
            setIsWorking(true);
            const saveService = new SaveService(loginContext.loginService.http);
            const userSolution = await saveService.save(ec, name, overwrite);
            props.onSaved(userSolution);
        }
        finally {
            setIsWorking(false);
        }
    }

    const btnSaveClasses = [
        "btn",
        "btn-primary",
        "btn-block"
    ];
    if (!canSave) {
        btnSaveClasses.push("disabled");
    }
    const btnOverwriteClasses = [
        "btn",
        "btn-primary",
        "btn-block"
    ];
    if (!canSave) {
        btnOverwriteClasses.push("disabled");
    }
    const absStyle: React.CSSProperties = {
        position: "absolute",
        width: "100%",
        height: "100%",
    }


    return (
        <Modal onHide={props.onClose}
            show
            animation={false}
            centered
            size="sm"
            className="save-modal">

            <Modal.Header
                closeButton
                closeLabel={tc.translator("modal close label", "Luk")}>
                <Modal.Title>
                    {tc.translator("save modal header", "Gem løsning")}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div>
                    {tc.translator(
                        "save modal instructions",
                        "Giv din løsning et navn, så vi kan hjælpe dig med at finde den frem i forretningen.")}
                </div>
                {(props.errorFlags !== 0) && <div className="alert alert-warning">
                    {tc.translator(
                        "save modal errors",
                        "Din løsning indeholder en eller flere fejl, som du bør rette inden bestilling."
                    )}
                </div>}

                <form onSubmit={evt => { evt.preventDefault(); save(false); }}>
                    <input name="name"
                        value={name}
                        className="form-control"
                        required
                        autoFocus
                        onChange={evt => setName(evt.target.value)} />

                    <button type="submit"
                        className={btnSaveClasses.join(" ")}
                        style={{marginTop: "8px",}}
                        disabled={!canSave}
                    >
                        <div style={{ position: "relative" }}>
                            <div style={absStyle}>
                                <LoadSpinner isVisible={isWorking} color="light" />
                            </div>
                            <div style={{ visibility: isWorking ? "hidden" : "visible" }}>
                                {tc.translator("save modal save button text", "Gem løsning")}
                            </div>
                        </div>
                    </button>

                    {canOverwrite && (
                        <button type="button"
                            className={btnOverwriteClasses.join(" ")}
                            disabled={!canSave}
                            onClick={evt => save(true)}
                        >
                            <div style={{ position: "relative" }}>
                                <div style={absStyle}>
                                    <LoadSpinner isVisible={isWorking} color="light" />
                                </div>
                                <div style={{ visibility: isWorking ? "hidden" : "visible" }}>
                                    {tc.translator("save modal overwrite button text", "Overskriv")}
                                </div>
                            </div>
                        </button>
                    )}

                </form>

            </Modal.Body>
        </Modal>
    );
}
